import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ServerErrorService {
  private _serverError$ = new BehaviorSubject<boolean>(false);

  public get serverError$(): Observable<boolean> {
    return this._serverError$.asObservable();
  }

  public setServerError(value: boolean): void {
    this._serverError$.next(value);
  }
}
